import { Fancybox } from '@fancyapps/ui';

export default function initModal() {
  const focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let opener = null;

  document.querySelectorAll('[data-fancybox]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      opener = trigger;
    });
  });

  document.addEventListener('keydown', e => {
    if (e.key !== 'Tab') return;

    const content = document.querySelector('.modal');
    if (!content) return;

    const focusable = [...content.querySelectorAll(focusableSelectors)];
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  const observer = new MutationObserver(() => {
    if (!document.querySelector('.fancybox__dialog') && opener) {
      opener.focus();
      opener = null;
    }
  });

  observer.observe(document.body, { childList: true });

  Fancybox.bind('[data-fancybox]:not([data-fancybo-video])', {
    closeButton: false,
    autoFocus: true,
    backdropClick: false,
  });

  Fancybox.bind('[data-fancybox-video]', {
    closeButton: true,
    autoFocus: false,
    backdropClick: true,
  });
}
